module.exports = __webpack_public_path__ + "img/header_grad_round.09fc0014.png";